// components/industry-templates/BiotechEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Dna, Microscope, FlaskRound, Award } from 'lucide-react';

export const BiotechEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-green-500/20 to-teal-500/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Dna className="w-8 h-8" style={{ color: theme.primary }} />
            Biotech Research & Innovation
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {industryData?.biotech_research?.map((research: any, idx: number) => (
              <div key={idx} className="p-5 bg-white/10 rounded-xl border-2" style={{ borderColor: theme.primary }}>
                <h3 className="text-xl font-bold text-white mb-2">{research.title}</h3>
                <p className="text-slate-300 text-sm mb-3">{research.description}</p>
                <Badge style={{ backgroundColor: theme.primary }}>{research.field}</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
